/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TodoItemDto } from '../models/TodoItemDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class TodoItemControllerService {

    /**
     * @param id
     * @returns TodoItemDto OK
     * @throws ApiError
     */
    public static getTodo(
        id: string,
    ): CancelablePromise<TodoItemDto> {
        return __request({
            method: 'GET',
            path: `/todo-items/${id}`,
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns TodoItemDto OK
     * @throws ApiError
     */
    public static updateTodo(
        id: string,
        requestBody: TodoItemDto,
    ): CancelablePromise<TodoItemDto> {
        return __request({
            method: 'PUT',
            path: `/todo-items/${id}`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAllTodo(
        id: string,
    ): CancelablePromise<any> {
        return __request({
            method: 'DELETE',
            path: `/todo-items/${id}`,
        });
    }

    /**
     * @returns TodoItemDto OK
     * @throws ApiError
     */
    public static getAllTodoItems(): CancelablePromise<Array<TodoItemDto>> {
        return __request({
            method: 'GET',
            path: `/todo-items`,
        });
    }

    /**
     * @param requestBody
     * @returns TodoItemDto OK
     * @throws ApiError
     */
    public static saveTodo(
        requestBody: TodoItemDto,
    ): CancelablePromise<TodoItemDto> {
        return __request({
            method: 'POST',
            path: `/todo-items`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}